module.exports = __webpack_public_path__ + "static/media/blogOne.4c518266.webp";